import React, { useState } from "react";
import { ArrowRight, Bell } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { track } from "@/lib/analytics";
import { PRE_HARVEST_MODE } from "@/lib/siteMode";
import WaitlistForm from "../WaitlistForm";

export default function FinalCTA() {
  const { t, lang } = useLang();
  const [showWaitlist, setShowWaitlist] = useState(false);
  return (
    <section
      id="cta-final"
      data-testid="final-cta-section"
      className="relative bg-cream-100 pt-24 sm:pt-32 lg:pt-40 pb-24"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="relative border border-olive-700/30 px-8 py-20 sm:py-28 lg:py-36 text-center overflow-hidden bg-cream-200">
          {/* Brand crest watermark */}
          <img
            src="https://customer-assets.emergentagent.com/job_aceite-granada/artifacts/d8ycwu18_Logo%20CSM.webp"
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 select-none"
            style={{
              width: "min(60vw, 520px)",
              height: "auto",
              opacity: 0.06,
              mixBlendMode: "multiply",
            }}
            draggable={false}
          />
          <div className="relative max-w-3xl mx-auto">
            <span className="text-[11px] uppercase tracking-[0.32em] text-gold-deep font-medium">
              {t("final_cta.overline")}
            </span>
            <h2 className="mt-8 font-serif text-5xl sm:text-6xl lg:text-[88px] leading-[0.98] text-olive-900 font-medium">
              {t("final_cta.h2_a")} <span className="italic">{t("final_cta.h2_b")}</span>
              <br />
              {t("final_cta.h2_c")}
            </h2>
            <p className="mt-8 text-base sm:text-lg text-olive-800/80 font-light max-w-xl mx-auto leading-relaxed">
              {t("final_cta.body")}
            </p>
            <div className="mt-12 flex flex-wrap justify-center gap-4">
              {PRE_HARVEST_MODE ? (
                <>
                  <button
                    type="button"
                    data-testid="final-cta-primary"
                    onClick={() => {
                      track("cta_click", { cta: "final_waitlist_primary", location: "final_cta" });
                      setShowWaitlist(true);
                    }}
                    className="inline-flex items-center gap-3 px-10 py-5 bg-olive-700 text-cream-100 text-[12px] uppercase tracking-[0.26em] hover:bg-olive-800 transition-colors duration-300 group"
                  >
                    <Bell size={16} strokeWidth={1.2} />
                    {t("final_cta.cta_primary")}
                  </button>
                  <a
                    href="#historia"
                    data-testid="final-cta-secondary"
                    onClick={() => track("cta_click", { cta: "final_discover_estate", location: "final_cta" })}
                    className="inline-flex items-center gap-3 px-10 py-5 border border-olive-700 text-olive-800 text-[12px] uppercase tracking-[0.26em] hover:bg-cream-100 transition-colors duration-300"
                  >
                    {t("final_cta.cta_secondary")}
                  </a>
                </>
              ) : (
                <>
                  <a
                    href="/tienda"
                    data-testid="final-cta-primary"
                    onClick={() => track("cta_click", { cta: "final_shop_primary", location: "final_cta" })}
                    className="inline-flex items-center gap-3 px-10 py-5 bg-olive-700 text-cream-100 text-[12px] uppercase tracking-[0.26em] hover:bg-olive-800 transition-colors duration-300 group"
                  >
                    {t("final_cta.cta_primary")}
                    <ArrowRight size={16} strokeWidth={1.2} className="transition-transform group-hover:translate-x-1" />
                  </a>
                  <a
                    href="/producto/estuche-madera-2x500ml"
                    data-testid="final-cta-secondary"
                    onClick={() => track("cta_click", { cta: "final_gift_secondary", location: "final_cta" })}
                    className="inline-flex items-center gap-3 px-10 py-5 border border-olive-700 text-olive-800 text-[12px] uppercase tracking-[0.26em] hover:bg-cream-100 transition-colors duration-300"
                  >
                    {t("final_cta.cta_secondary")}
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {showWaitlist && <WaitlistForm onClose={() => setShowWaitlist(false)} />}
    </section>
  );
}
